import {items as itemsApi} from '../../api';
const downloadjs = require('downloadjs');

export const REQUEST_ITEM_SEARCH_ACTION = 'REQUEST_ITEM_SEARCH_ACTION';
export const RECEIVE_ITEM_SEARCH_SUCCESS = 'RECEIVE_ITEM_SEARCH_SUCCESS';
export const RECEIVE_ITEM_SEARCH_FAILURE = 'RECEIVE_ITEM_SEARCH_FAILURE';
export const RECEIVE_ITEM_DOWNLOAD_SUCCESS = 'RECEIVE_ITEM_DOWNLOAD_SUCCESS';

const requestItemSearch = (params) => ({
  type: REQUEST_ITEM_SEARCH_ACTION,
  payload: {
    params
  },
});

const receiveItemSearchSuccess = (searchResults) => ({
  type: RECEIVE_ITEM_SEARCH_SUCCESS,
  payload: {
    searchResults
  },
});

const receiveItemDownloadSucccess = ({
  type: RECEIVE_ITEM_DOWNLOAD_SUCCESS,
});

const receiveItemSearchFailure = (error) => ({
  type: RECEIVE_ITEM_SEARCH_FAILURE,
  payload: {
    error
  },
});

export const search = (params) =>
  (dispatch) => {
    dispatch(requestItemSearch(params));

    const {text, tags, affix, notoriety, categories, skip, limit, minimumLevel, maximumLevel, minimumiLevel, maximumiLevel} = params;

    const searchTags = [...(tags || []), ...(affix || []), ...(notoriety || [])];

    return itemsApi.search(text || '', categories || [], searchTags, skip || 0, limit || 50, "false", minimumLevel, maximumLevel, minimumiLevel, maximumiLevel)
      .then( (response) => {
        dispatch(receiveItemSearchSuccess(response.data));
      }).catch( (error) => {
        dispatch(receiveItemSearchFailure(error));
      });
  }

export const download = (params) =>
  (dispatch) => {
    dispatch(requestItemSearch(params));

    const {text, tags, categories, skip, limit, minimumLevel, maximumLevel, minimumiLevel, maximumiLevel} = params;

    return itemsApi.search(text || '', categories || [], tags || [], skip || 0, limit || 50, "true", minimumLevel, maximumLevel, minimumiLevel, maximumiLevel)
      .then( (response) => {
        downloadjs(response.data, 'items.csv', response.headers['content-type']);
        dispatch(receiveItemDownloadSucccess());
      }).catch( (error) => {
        dispatch(receiveItemSearchFailure(error));
      });
}



// WEBPACK FOOTER //
// ./src/search/actions/itemSearchActions.js